export default function Project({ title, anchor, year }) {
  return (
    <a href={"#" + anchor}>
      <div className="menu-item glassy">
        <div>{title}</div>
        <div className="year">{year}</div>
      </div>
    </a>
  )
}
